import React from 'react';
import Column from '../../components/base/column';
import styles from './index.module.css';

export default function PartnerPage() {
    return <Column className={styles.container}>Partner Page</Column>;
}
